"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleDownloadLink = void 0;
/**
 * Force browser to directly download file
 */
const handleDownloadLink = (fileUrl, fileName) => async event => {
  event.preventDefault();
  if (!fileUrl || !fileName) {
    return;
  }
  try {
    const response = await fetch(fileUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    Object.assign(anchor, {
      href: url,
      download: fileName
    });
    anchor.click();
    URL.revokeObjectURL(url);
  } catch (error) {
    console.error('File download failed:', error);
  }
};
exports.handleDownloadLink = handleDownloadLink;
